import { FC } from "react";
import { TAllMarkets } from "../../../types/markets/market";
import cancel from "../../../assets/images/delete_icon.svg";
import { TLoanFiltersData } from "../../../types";
import SingleSelectDropdownWithInnerSearch from "../../../components/ui/single-select-dropdown-search";

const DeleteMarket: FC<{
  allMarketsData: TAllMarkets[];
  selectDeleteMarkets: TLoanFiltersData | null;
  setSelectDelMarkets: any;
  marketName: string;
  selectedMarketId: any;
}> = ({
  allMarketsData,
  selectDeleteMarkets,
  setSelectDelMarkets,
  marketName,
  selectedMarketId,
}) => {
  const marketOptions = allMarketsData
    ?.filter((item) => item.marketId !== selectedMarketId)
    ?.map((item) => ({
      id: item.marketId,
      label: item.marketName,
      value: item.marketName.toLowerCase().replace(/\s+/g, ""),
      mobile: "",
      type: "MARKET ID",
      profilePic: "",
      address: "",
    }));
  return (
    <div>
      <div className="text-center flex flex-col gap-4 text-sm ">
        <div className="flex justify-center">
          <img src={cancel} className="w-10 " />
        </div>
        <p>
          This will permanently delete all data from{" "}
          <span className="font-bold">{marketName}</span>. If you don’t want to
          lose it, you can move the data to another market first.
        </p>
        <p>Are you sure you want to continue</p>
      </div>
      <div className="mt-4">
        <label className="fs-14 pb-1">Market Name</label>
        <SingleSelectDropdownWithInnerSearch
          options={marketOptions}
          selected={selectDeleteMarkets}
          onChange={setSelectDelMarkets}
          placeholder="Select Market..."
          fromDeleteMarketScreen={true}
        />
      </div>
    </div>
  );
};
export default DeleteMarket;
